import { createContext } from 'react';
import { Tracker } from './tracker';

const tracker = Tracker.getInstance();

const context = createContext<Tracker>(tracker);

export const TrackingConsumer = context.Consumer;
